export default function getResource(label) {
    const resources = {
        itemsInOrder: 'Items in order',
        itemInOrder: 'Item in order',
        sameDayDeliveryItems: 'Same-Day Delivery Items',
        fastDeliveryItems: 'Fast Delivery Items'
    };

    return resources[label];
}
